/**
 * @typedef {Object} TDaysOfWeek - Days of the week to apply to a given entity.
 * @property {boolean} monday
 * @property {boolean} tuesday
 * @property {boolean} wednesday
 * @property {boolean} thursday
 * @property {boolean} friday
 * @property {boolean} saturday
 * @property {boolean} sunday
 */

/**
 * Used for rules with duration <=24h, can be repeated on a daily basis, e.g. 9am - 5pm every M - F
 *
 * @constant
 * @type {string}
 */
export const DAILY = 'daily';

/**
 * Used for rules with duration >24h and < 8 days, can be repeated on a weekly basis, e.g. 4am Monday to 9pm Wednesday every week
 *
 * @constant
 * @type {string}
 */
export const CONTINUOUS = 'continuous';

/**
 * Use for rules applied to a designated event, e.g. a concert
 *
 * @constant
 * @type {string}
 */
export const EVENT = 'event';

/**
 *
 * @type {string}
 */
export const EVENT_FILTER = 'event_filter';

/**
 * Used for non-recurring, one-off rules with a specific start and end datetime, e.g. 9am on 09/28/2020 to 10pm on 10/12/2020
 *
 * @constant
 * @type {string}
 */
export const EXCEPTION = 'exception';

export const INVENTORY_RULE_TYPE_ITEMS = [
    {label: 'Day', value: DAILY},
    {label: 'Time Period', value: CONTINUOUS},
];

export const INVENTORY_RULE_DOW = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday',
];

export const INVENTORY_RULE_DOW_ABBR = {
    monday: 'M',
    tuesday: 'T',
    wednesday: 'W',
    thursday: 'Th',
    friday: 'F',
    saturday: 'S',
    sunday: 'Su',
};

export default {
    DAILY,
    CONTINUOUS,
    EXCEPTION,
    EVENT,
    EVENT_FILTER,
};
